module.exports = ".upload-button {\n  background-color: #9d0000;\n  width: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.component.scss
// module id = ./src/app/settings/settings.component.scss
// module chunks = main